import React, { useCallback, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Button } from '~/eds/src/components/Button/Button';

import { DEFAULT_INDENT_PX } from './NameCell';

export interface LoadMoreCellProps {
  onClick: () => Promise<void>;
  indentLevel: number;
}

const messages = defineMessages({
  loadMore: {
    id: 'groups.loadMore',
    defaultMessage: 'Load More',
  },
});

export const LoadMoreCell = ({ onClick, indentLevel }: LoadMoreCellProps) => {
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  // Add 40px to the indent to account for the padding for the expand icon so the nodes line up
  const indent = DEFAULT_INDENT_PX * (indentLevel - 1) + 24;

  const handleClick = useCallback(async () => {
    setIsLoading(true);
    await onClick();
    setIsLoading(false);
  }, [onClick]);

  return (
    <Box pl={indent}>
      <Button
        variant="action"
        onClick={handleClick}
        isLoading={isLoading}
        text={intl.formatMessage(messages.loadMore)}
      />
    </Box>
  );
};
